export default "<div class=\"chevron\">\r\n    <span class=\"text\" *ngIf=date>\r\n      Latest Available Data: {{date[key]}}\r\n    </span>\r\n</div>\r\n"